customElements.define('product-form', class ProductForm extends HTMLElement {
  constructor() {
    super();   

    this.form = this.querySelector('form');
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    this.cartDrawer = document.querySelector('cart-drawer');
    this.connectedForm = document.querySelector(`sticky-atc[data-main-form="${this.form.getAttribute("id")}"]`) || ""
    const header = document.querySelector(".header-wrapper")
    const mainATC = document.querySelector(".product-form__submit")
    const bisButton = this.form.querySelector('[data-bis-button]')

    if(bisButton) {
      bisButton.addEventListener('click', () => {
        const email = this.form.querySelector('#bis-email').value
        const variant = this.form.querySelector('#bis-variant').value
        const optIn = this.form.querySelector('#bis-newsletter-optin').checked

        this.submitBackInStock(email, variant, optIn)
      })
    }

    const observer = new IntersectionObserver(
      entries => {
        entries.forEach( entry => {
          if(entry.boundingClientRect.y < entry.rootBounds?.height)
          this.connectedForm.classList.toggle("show", !entry.isIntersecting)
        })
      },
      {
        rootMargin: `-${(header.clientHeight)}px`,
        threshold: 0
      }
    )

    if(this.connectedForm){
      observer.observe(mainATC)
    }
    
  }

  submitBackInStock(email, variant, optIn){
    const options = {
      method: 'POST',
      headers: {
        accept: 'application/json',
        revision: '2023-07-15',
        'content-type': 'application/json'
      },
      body: JSON.stringify({
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            channels: ['EMAIL'], 
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email
                }
              }
            }
          },
          relationships: {
            variant: {
              data: {
                type: 'catalog-variant',
                id: `$shopify:::$default:::${parseInt(variant)}`
              }
            }
          }
        }
      })
    };

    fetch("https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=U4cCN4", options)
    .then(response => {
      if (response.ok) {
        document.querySelector('#bis-response').textContent = "Thanks for signing up! You'll get an email when this product is back in stock."
        document.querySelector('#bis-input').classList.add('hidden')
      } else {
        response.json().then(response => {
        const errorMessage = response.errors.map(e => {return e.detail}).toString()
        console.log(errorMessage)
        document.querySelector('#bis-response').textContent = errorMessage
        })
      }
    })
    .finally(() => {
      if( optIn == true ){
        const options = {
          method: 'POST',
          headers: {revision: '2023-07-15', 'content-type': 'application/json'},
          body: JSON.stringify({
            data: {
              type: 'subscription',
              attributes: {
                profile: {
                  data: {
                    type: 'profile',
                    attributes: {
                      email: email,
                    }
                  }
                }
              },
              relationships: {list: {data: {type: 'list', id: 'XzBDyk'}}}
            }
          })
        };
      
        fetch('https://a.klaviyo.com/client/subscriptions/?company_id=U4cCN4', options)
        .then((response) => {
          console.log(response)
          document.querySelector('#bis-response').classList.remove('hidden')
        })
      } else {
        document.querySelector('#bis-response').classList.remove('hidden')
      }

      
    })
    .catch(error => {
      document.querySelector('#bis-response').textContent = error
      document.querySelector('#bis-response').classList.remove('hidden')
      console.log("Error:", error)
    });
  }

  onSubmitHandler(evt) {
    evt.preventDefault();
    
    const submitButton = this.querySelector('[type="submit"]');

    submitButton.setAttribute('disabled', true);
    submitButton.classList.add('loading');

    // if type is back in stock
    if(submitButton.name == 'back-in-stock') {
      // show notify me form
      this.form.querySelector('#bis-form').classList.remove('hidden')
      this.form.querySelector('#bis-email').focus()
      submitButton.classList.remove('loading');
      return
    }

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    const formData = new FormData(this.form);

    formData.append(
      'sections',
      this.getSectionsToRender().map((section) => section.section)
    );
    formData.append('sections_url', window.location.pathname);

    config.body = formData

    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((parsedState) => {

        this.getSectionsToRender().forEach((section => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

          elementToReplace.innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);

        }));
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        submitButton.classList.remove('loading');
        submitButton.removeAttribute('disabled');
        if(this.connectedForm){
          this.connectedForm.querySelector("button[type='submit']").classList.remove('loading')
        }
        this.cartDrawer.open();
        this.cartDrawer.initEvents();
      });
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer__content',
        section: document.getElementById('cart-drawer__content').dataset.id,
        selector: '.cart-drawer__content',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  handleErrorMessage(errorMessage = false) {
    this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
    this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

    this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

    if (errorMessage) {
      this.errorMessage.textContent = errorMessage;
    }
  }
});